<template>
  <div v-if="!loadingGov">
    <dialog  class="text p-0" ref="dialog"  id="info"  >
        <div class="dialog yes-no flex-col animate" ref="dialogCont">
          <p class="yes-no w-4/5">
          هذا الطلب مكرر هل انت واثق أنك تريد ارساله مرة أخرى؟
          </p>
         <p class=" m-auto w-1/2 yes-no mt-32 ">
          <button class="yes mr-3" 
          @click="submitData_2(1)"
          >نعم</button>
          <button 
          @click="closeDialog"
          class="no">لا</button>
         </p>
        </div>
      </dialog>
    <v-tour :options="tourOptions"   name="addOrder" :steps="steps"></v-tour>
    <div  class="title-page flex justify-between text-center">
      <div>
        <feather-icon icon="PackageIcon" svgClasses="h-4 w-4"></feather-icon>
        <h3
          class="font-bold mb-2 ml-3"
          style="display: inline-block; font-size: 1.125rem"
        >
        {{ Object.keys(resend_with_new_order).length > 0 ? $t("addOrderToResend") : $t("addOrder") }}
        </h3>
      </div>
    </div>
    <div class="line"></div>
    <div data-order-tour-step="1">
      <div class="p-6 bg-white form-inputs" >
        <div class="first-input">
          <!-- sender -->
          <label class="font-bold">
            {{ $t("sender") }} :({{ $t("optional") }})
          </label>
          <SelectInputVue
            v-model="orderData.second_client"
            maxlength="100"
            name="sender"
            type="text"
            class="input"
            :placeholder="$t('sender')"
            :options="resultSubCustomers"

          />
          <span style="font-size: 0.7rem" class="text-danger err-msg">{{
            errors.first("sender")
          }}</span>
        </div>
        <div class="first-input">
          <!-- receiver -->
          <label class="font-bold">
            {{ $t("receiver") }} :
            <span style="font-size: 1.2rem" class="text-danger font-bold"
              >*</span
            >
            </label
          >
          <input
            v-model="orderData.receiver"
            name="receiver"
            v-validate="'required|min:3'"
            maxlength="100"
            type="text"
            class="input"
            :placeholder="$t('exampleReceiver')"
          />
          <span style="font-size: 0.7rem" class="text-danger err-msg">{{
            errors.first("receiver")
          }}</span>
        </div>
        <div class="first-input">
          <!-- number1 -->
          <label class="font-bold">
            {{ $t("number1") }} :
            <span style="font-size: 1.2rem" class="text-danger font-bold"
              >*</span
            ></label
          >
          <vue-tel-input
            v-model="orderData.phone1"
            mode="international"
            :inputOptions="internationalInputOptions"
            :defaultCountry="'LY'"
            :validCharactersOnly="true"
            @validate="phoneObject($event, 'phone1')"
            @input="clearErrorMessage('phone1')"
            name="number"
            v-validate="'required'"
          ></vue-tel-input>
          <span style="font-size: 0.7rem" class="text-danger err-msg"
            >{{ errors.first("number")
            }}<span v-if="!this.validationsPhone.phone1 && orderData.phone1"
              >يجب ادخال رقم هاتف صحيح</span
            >
            <span v-if="orderData.phone1ErrorMessage">{{ orderData.phone1ErrorMessage }}</span>
          </span>
         <span v-if="showCustomerRate" :class="['customer-rate-alert', customerRateData.alertClass]">
            {{ customerRateData.headerText }}
          </span>
        </div>
        <div class="second-input">
          <!-- number2 -->
          <label class="font-bold">
            {{ $t("number2") }} :({{ $t("optional") }})
          </label>
          <vue-tel-input
            v-model="orderData.phone2"
            mode="international"
            :inputOptions="internationalInputOptions"
            :defaultCountry="'LY'"
            :validCharactersOnly="true"
            @validate="phoneObject($event, 'phone2')"
            @input="clearErrorMessage('phone2')"
            name="number2"
          ></vue-tel-input>
          <span style="font-size: 0.7rem" class="text-danger err-msg"
            >{{ errors.first("number2") }}
            <span v-if="!this.validationsPhone.phone2"
              >يجب ادخال رقم هاتف صحيح</span
            >
            <span v-if="orderData.phone2ErrorMessage">{{ orderData.phone2ErrorMessage }}</span>
            </span
          >
        </div>
        <div class="second-input">
          <!-- numbreTracking -->
          <label class="font-bold">
            {{ $t("numbreTracking") }} :({{ $t("optional") }})
          </label>
          <vue-tel-input
            v-model="orderData.api_followup_phone"
            mode="international"
            :inputOptions="internationalInputOptions"
            :defaultCountry="'LY'"
            :validCharactersOnly="true"
            @validate="phoneObject($event, 'api_followup_phone')"
            @input="clearErrorMessage('api_followup_phone')"
            name="api_followup_phone"
          ></vue-tel-input>
          <span style="font-size: 0.7rem" class="text-danger err-msg"
            >{{ errors.first("mobileFollow")
            }}<span v-if="!this.validationsPhone.api_followup_phone"
              >يجب ادخال رقم هاتف صحيح</span
            >
            <span v-if="orderData.api_followup_phoneErrorMessage">{{ orderData.api_followup_phoneErrorMessage }}</span>
          </span>
        </div>
        <div class="second-input">
          <label class="label-select font-bold" ref="govLabel"
            >{{ $t("government") }} :
            <span style="font-size: 1.2rem" class="text-danger font-bold"
              >*</span
            ></label
          >
          <SelectInputVue
            :options="resultGovs"
            v-model="orderData.government_id"
            @input="changeRegions(orderData.government_id, orderData.is_office_given)"
            v-validate="'required'"
            name="government"
          >
            <template #search>
              <input
                @blur.stop
                class="inner-input"
                v-model="search"
                @input="searchGov()"
                placeholder="إبحث هنا"
              />
            </template>
          </SelectInputVue>
          <span style="font-size: 0.7rem" class="text-danger font-bold">{{
            errors.first("government")
          }}</span>
          <span v-if="resultCost && orderData.government_id && !areaResultCost" style="font-size: 0.7rem" class="font-bold">
            تكلفة الشحن {{ resultCost}}
          </span>
        </div>
        <div class="second-input">
          <label class="label-select font-bold" ref="govLabel"
            >{{ $t("area") }} :
            <span style="font-size: 1.2rem" class="text-danger font-bold"
              v-bind:style = "(this.$store.state.externalApi.required_regions)?'':'display:none;'"
              >*</span
            ></label
          >
          <div v-if="!loadingRegions">
            <SelectInputVue
              :options="resultRegions"
              v-model="orderData.area_id"
              @input="changeAreas(orderData.area_id, orderData.is_office_given)"
              name="area"
              v-validate="{ required: this.$store.state.externalApi.required_regions }"
            >
              <template #search>
                <input
                  @blur.stop
                  class="inner-input"
                  v-model="searchAreaWord"
                  @input="searchArea()"
                  placeholder="إبحث هنا"
                />
              </template>
            </SelectInputVue>
            <span style="font-size: 0.7rem" class="text-danger font-bold">{{
              errors.first("area")
            }}</span>
          <span v-if="areaResultCost && orderData.area_id" style="font-size: 0.7rem" class="font-bold">
            تكلفة الشحن {{ areaResultCost}}
          </span>
          </div>
          <SkeletonLoadingVue v-else />
        </div>
        <div class="third-input">
          <!-- address -->
          <label class="font-bold">
            {{ $t("address") }} :({{ $t("optional") }})
            <!-- <span style="font-size: 1.2rem" class="text-danger font-bold"
              >*</span
            > -->
          </label>
          <input
            :disabled="orderData.is_office_given"
            v-model="orderData.address"
            type="text"
            maxlength="100"
            name="address"
            class="input"
            :placeholder="$t('exampleAddress')"
          />
          <span style="font-size: 0.7rem" class="text-danger err-msg">{{
            errors.first("address")
          }}</span>
        </div>
        <div class="third-input">
          <!-- notes -->
          <label class="font-bold">
            {{ $t("notes") }} :({{ $t("optional") }})
          </label>
          <input
            maxlength="250"
            minlength="3"
            v-model="orderData.notes"
            type="text"
            class="input"
            :placeholder="$t('exampleNotes')"
          />
          <!-- <span style="font-size: 0.7rem" class="text-danger">{{}}</span> -->
        </div>
        <div class="four-input">
          <!-- collectedAmount -->
          <label class="font-bold">
            {{ $t("itemPrice") }} :
            <span style="font-size: 1.2rem" class="text-danger font-bold"
              >*</span
            >
          </label>
          <input
            v-validate="'numeric|required'"
            @paste="remvoeSpace('orderData', 'amount_to_be_collected')"
            name="collectedAmount"
            ref="collectedAmount"
            maxlength="20"
            v-model="orderData.amount_to_be_collected"
            type="text"
            class="input"
            :placeholder="$t('exampleAmountOrValue')"
          />
          <span style="font-size: 0.7rem" class="text-danger err-msg">{{
            errors.first("collectedAmount")
          }}</span>
          <span
            v-if="orderData.amount_to_be_collected >= 2000"
            style="font-size: 0.7rem"
            class="text-danger err-msg"
            >{{ $t("additionalFeesMayApply") }}</span
          >
        </div>
        <!-- returnValue -->
         <!--
        <div class="four-input">
          <label class="font-bold">
            {{ $t("returnValue") }} :({{ $t("optional") }})
            <span style="font-size: 1.2rem" class="text-danger font-bold"
              >*</span
            >
          </label>
          <input
            v-validate="'numeric'"
            @paste="remvoeSpace('orderData', 'return_amount')"
            name="returnValue"
            ref="returnValue"
            maxlength="20"
            v-model="orderData.return_amount"
            type="text"
            class="input"
            :placeholder="$t('exampleAmountOrValue')"
          />
          <span style="font-size: 0.7rem" class="text-danger err-msg">{{
            errors.first("returnValue")
          }}</span>
        </div>
        -->
        <div class="four-input">
          <!-- invoiceNumber -->
          <label class="font-bold">
            {{ $t("invoiceNumber") }} :({{ $t("optional") }})
          </label>
          <input
            v-model="orderData.invoice_number"
            class="input"
            :placeholder="$t('exampleInvoice')"
          />
          <!-- <span style="font-size: 0.7rem" class="text-danger">{{}}</span> -->
        </div>
        <div class="four-input">
          <!-- contentOrder -->
          <label class="font-bold">
            {{ $t("contentOrder") }} :
            <span style="font-size: 1.2rem" class="text-danger font-bold"
              >*</span
            >
          </label>
          <input
          v-validate="'required|min:3'"
            maxlength="100"
            v-model="orderData.order_summary"
            type="text"
            class="input"
            name="contentOrder"
            :placeholder="$t('exampleContentOrder')"
          />
          <span style="font-size: 0.7rem" class="text-danger err-msg">{{
            errors.first("contentOrder")
          }}</span>
        </div>
        <div class="four-input">
          <!-- Total Amount -->
          <label class="font-bold">
            {{ $t("totalAmount") }}
          </label>
          <input
            v-model="totalAmount"
            maxlength="20"
            type="number"
            class="input"
            name="totalAmount"
            disabled
            :placeholder="$t('totalAmount')"
          />
        </div>
        <div class="four-input">
          <!-- piecesCount -->
          <label class="font-bold">
            {{ $t("piecesCount") }} 
          </label>
          <input
          v-validate="'numeric'"
            v-model="orderData.pieces_count"
            maxlength="20"
            type="number"
            class="input"
            name="piecesCount"
            :placeholder="$t('piecesCount')"
          />
          <span style="font-size: 0.7rem" class="text-danger err-msg">{{
            errors.first("pieces_count")
          }}</span>
        </div>
       <!-- Order Bank payment Options -->
        <div class="bank-payment-wrapper">
          <div class="bank-payment-card">
            <!-- Checkbox -->
            <div class="bank-checkbox">
              <input type="checkbox" id="is_bank_payment" v-model="orderData.is_bank_payment" />
              <label for="is_bank_payment">
                {{ $t('IsBankPayment') }}
              </label>
            </div>
            <!-- Commission payer -->
            <div v-if="orderData.is_bank_payment" class="bank-commission">
              <span class="commission-title">
                {{ $t('bankPaymentCommission') }}
              </span>
             <div class="w-full flex-wrap" style="display: flex; align-items: center; grid-column: span 4">
                <span style="display: flex; align-items: center" class="mt-2 mr-2">
                  <span class="checked" v-if="orderData.payment_commission_payer == 1">
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18">
                      <path id="Icon_material-check-circle" data-name="Icon material-check-circle"
                        d="M12,3a9,9,0,1,0,9,9A9,9,0,0,0,12,3ZM10.2,16.5,5.7,12l1.269-1.269L10.2,13.953l6.831-6.831L18.3,8.4Z"
                        transform="translate(-3 -3)" fill="#31006F" />
                    </svg>
                  </span>
                  <span class="unchecked" v-if="orderData.payment_commission_payer != 1" @click="orderData.payment_commission_payer = 1">
                    <svg xmlns="http://www.w3.org/2000/svg" width="17.92" height="17.92" viewBox="0 0 17.92 17.92">
                      <path id="Icon_material-radio-button-unchecked" data-name="Icon material-radio-button-unchecked"
                        d="M11.96,3a8.96,8.96,0,1,0,8.96,8.96A8.963,8.963,0,0,0,11.96,3Zm0,16.128a7.168,7.168,0,1,1,7.168-7.168A7.166,7.166,0,0,1,11.96,19.128Z"
                        transform="translate(-3 -3)" />
                    </svg>
                  </span>
                  <input style="cursor: pointer" :value="1" v-model="orderData.payment_commission_payer" id="paymentCommission1"
                    class="custom-control-primary mr-1" type="radio" name="radiosGroup" />
                  <label style="cursor: pointer; font-size: 0.875rem; margin-left: 1.5rem" :style="[
                    orderData.payment_commission_payer == 1
                      ? { color: '#31006F' }
                      : { color: '#6E6B7B' },
                  ]" for="paymentCommission1">{{ $t('Receiver') }}</label>
                </span>

                <span style="display: flex; align-items: center" class="mt-2 mr-2">
                  <span class="checked" v-if="orderData.payment_commission_payer == 2">
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18">
                      <path id="Icon_material-check-circle" data-name="Icon material-check-circle"
                        d="M12,3a9,9,0,1,0,9,9A9,9,0,0,0,12,3ZM10.2,16.5,5.7,12l1.269-1.269L10.2,13.953l6.831-6.831L18.3,8.4Z"
                        transform="translate(-3 -3)" fill="#31006F" />
                    </svg>
                  </span>
                  <span class="unchecked" v-if="orderData.payment_commission_payer != 2" @click="orderData.payment_commission_payer = 2">
                    <svg xmlns="http://www.w3.org/2000/svg" width="17.92" height="17.92" viewBox="0 0 17.92 17.92">
                      <path id="Icon_material-radio-button-unchecked" data-name="Icon material-radio-button-unchecked"
                        d="M11.96,3a8.96,8.96,0,1,0,8.96,8.96A8.963,8.963,0,0,0,11.96,3Zm0,16.128a7.168,7.168,0,1,1,7.168-7.168A7.166,7.166,0,0,1,11.96,19.128Z"
                        transform="translate(-3 -3)" />
                    </svg>
                  </span>
                  <input style="cursor: pointer" :value="2" v-model="orderData.payment_commission_payer" id="paymentCommission2"
                    class="custom-control-primary mr-1" type="radio" name="radiosGroup" />
                  <label style="cursor: pointer; font-size: 0.875rem; margin-left: 1.5rem" :style="[
                    orderData.payment_commission_payer == 2
                      ? { color: '#31006F' }
                      : { color: '#6E6B7B' },
                  ]" for="paymentCommission2">{{ $t('Sender') }}</label>
                </span>
              </div>
            </div>
          </div>
        </div>
        <!-- Do given order -->
        <p class="do-given font-bold">
          {{ $t("willOrderBe") }}
        </p>
        <div
          class="w-full flex-wrap"
          style="display: flex; align-items: center; grid-column: span 4"
        >
          <span
            style="display: flex; align-items: center"
            class="mt-2 mr-2"
            :key="item.id"
            v-for="item in orderTypes"
          >
            <span class="checked" v-if="orderData.is_order == item.id">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="18"
                height="18"
                viewBox="0 0 18 18"
              >
                <path
                  id="Icon_material-check-circle"
                  data-name="Icon material-check-circle"
                  d="M12,3a9,9,0,1,0,9,9A9,9,0,0,0,12,3ZM10.2,16.5,5.7,12l1.269-1.269L10.2,13.953l6.831-6.831L18.3,8.4Z"
                  transform="translate(-3 -3)"
                  fill="#31006F"
                />
              </svg>
            </span>
            <span
              class="unchecked"
              v-if="orderData.is_order != item.id"
              @click="orderData.is_order = item.id"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="17.92"
                height="17.92"
                viewBox="0 0 17.92 17.92"
              >
                <path
                  id="Icon_material-radio-button-unchecked"
                  data-name="Icon material-radio-button-unchecked"
                  d="M11.96,3a8.96,8.96,0,1,0,8.96,8.96A8.963,8.963,0,0,0,11.96,3Zm0,16.128a7.168,7.168,0,1,1,7.168-7.168A7.166,7.166,0,0,1,11.96,19.128Z"
                  transform="translate(-3 -3)"
                />
              </svg>
            </span>
            <input
              style="cursor: pointer"
              :value="item.id"
              v-model="orderData.is_order"
              :id="item.id"
              class="custom-control-primary mr-1"
              type="radio"
              name="radiosGroup"
            />
            <label
              style="cursor: pointer; font-size: 0.875rem; margin-left: 1.5rem"
              :style="[
                orderData.is_order == item.id
                  ? { color: '#31006F' }
                  : { color: '#6E6B7B' },
              ]"
              :for="item.id"
              >{{ item.name }}</label
            >
          </span>
        </div>
         <p class="do-given font-bold">{{ $t("ShippingPayer") }}</p>
        <div
          class="w-full flex-wrap"
          style="display: flex; align-items: center; grid-column: span 4"
        >
          <span
            style="display: flex; align-items: center"
            class="mt-2 mr-2"
          >
            <span class="checked" v-if="orderData.shipping_payer == 1">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="18"
                height="18"
                viewBox="0 0 18 18"
              >
                <path
                  id="Icon_material-check-circle"
                  data-name="Icon material-check-circle"
                  d="M12,3a9,9,0,1,0,9,9A9,9,0,0,0,12,3ZM10.2,16.5,5.7,12l1.269-1.269L10.2,13.953l6.831-6.831L18.3,8.4Z"
                  transform="translate(-3 -3)"
                  fill="#31006F"
                />
              </svg>
            </span>
            <span
              class="unchecked"
              v-if="orderData.shipping_payer != 1"
              @click="orderData.shipping_payer = 1"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="17.92"
                height="17.92"
                viewBox="0 0 17.92 17.92"
              >
                <path
                  id="Icon_material-radio-button-unchecked"
                  data-name="Icon material-radio-button-unchecked"
                  d="M11.96,3a8.96,8.96,0,1,0,8.96,8.96A8.963,8.963,0,0,0,11.96,3Zm0,16.128a7.168,7.168,0,1,1,7.168-7.168A7.166,7.166,0,0,1,11.96,19.128Z"
                  transform="translate(-3 -3)"
                />
              </svg>
            </span>
            <input
              style="cursor: pointer"
              :value="1"
              v-model="orderData.shipping_payer"
              id="shipping1"
              class="custom-control-primary mr-1"
              type="radio"
              name="radiosGroup"
              
            />
            <label
              style="cursor: pointer; font-size: 0.875rem; margin-left: 1.5rem"
              :style="[
                orderData.shipping_payer == 1
                  ? { color: '#31006F' }
                  : { color: '#6E6B7B' },
              ]" for="shipping1"
              >المستلم</label
            >
          </span>

          <span
            style="display: flex; align-items: center"
            class="mt-2 mr-2"
          >
            <span class="checked" v-if="orderData.shipping_payer == 2">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="18"
                height="18"
                viewBox="0 0 18 18"
              >
                <path
                  id="Icon_material-check-circle"
                  data-name="Icon material-check-circle"
                  d="M12,3a9,9,0,1,0,9,9A9,9,0,0,0,12,3ZM10.2,16.5,5.7,12l1.269-1.269L10.2,13.953l6.831-6.831L18.3,8.4Z"
                  transform="translate(-3 -3)"
                  fill="#31006F"
                />
              </svg>
            </span>
            <span
              class="unchecked"
              v-if="orderData.shipping_payer == 1"
              @click="orderData.shipping_payer = 2"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="17.92"
                height="17.92"
                viewBox="0 0 17.92 17.92"
              >
                <path
                  id="Icon_material-radio-button-unchecked"
                  data-name="Icon material-radio-button-unchecked"
                  d="M11.96,3a8.96,8.96,0,1,0,8.96,8.96A8.963,8.963,0,0,0,11.96,3Zm0,16.128a7.168,7.168,0,1,1,7.168-7.168A7.166,7.166,0,0,1,11.96,19.128Z"
                  transform="translate(-3 -3)"
                />
              </svg>
            </span>
            <input
              style="cursor: pointer"
              :value="2"
              v-model="orderData.shipping_payer"
              id="shipping2"
              class="custom-control-primary mr-1"
              type="radio"
              name="radiosGroup"
            />
            <label
              style="cursor: pointer; font-size: 0.875rem; margin-left: 1.5rem"
              :style="[
                orderData.shipping_payer != 1 
                  ? { color: '#31006F' }
                  : { color: '#6E6B7B' },
              ]" for="shipping2"
              >المرسل</label
            >
          </span>
          
        </div>
        <p class="do-given font-bold">{{ $t("ExtraCostPayer") }}</p>
        <div
          class="w-full flex-wrap"
          style="display: flex; align-items: center; grid-column: span 4"
        >
          <span
            style="display: flex; align-items: center"
            class="mt-2 mr-2"
          >
            <span class="checked" v-if="orderData.extra_cost_payer == 1">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="18"
                height="18"
                viewBox="0 0 18 18"
              >
                <path
                  id="Icon_material-check-circle"
                  data-name="Icon material-check-circle"
                  d="M12,3a9,9,0,1,0,9,9A9,9,0,0,0,12,3ZM10.2,16.5,5.7,12l1.269-1.269L10.2,13.953l6.831-6.831L18.3,8.4Z"
                  transform="translate(-3 -3)"
                  fill="#31006F"
                />
              </svg>
            </span>
            <span
              class="unchecked"
              v-if="orderData.extra_cost_payer != 1"
              @click="orderData.extra_cost_payer = 1"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="17.92"
                height="17.92"
                viewBox="0 0 17.92 17.92"
              >
                <path
                  id="Icon_material-radio-button-unchecked"
                  data-name="Icon material-radio-button-unchecked"
                  d="M11.96,3a8.96,8.96,0,1,0,8.96,8.96A8.963,8.963,0,0,0,11.96,3Zm0,16.128a7.168,7.168,0,1,1,7.168-7.168A7.166,7.166,0,0,1,11.96,19.128Z"
                  transform="translate(-3 -3)"
                />
              </svg>
            </span>
            <input
              style="cursor: pointer"
              :value="1"
              v-model="orderData.extra_cost_payer"
              id="extra_cost_payer1"
              class="custom-control-primary mr-1"
              type="radio"
              name="radiosGroup"
            />
            <label
              style="cursor: pointer; font-size: 0.875rem; margin-left: 1.5rem"
              :style="[
                orderData.extra_cost_payer == 1
                  ? { color: '#31006F' }
                  : { color: '#6E6B7B' },
              ]" for="extra_cost_payer1"
              >المستلم</label
            >
          </span>

          <span
            style="display: flex; align-items: center"
            class="mt-2 mr-2"
          >
            <span class="checked" v-if="orderData.extra_cost_payer == 2">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="18"
                height="18"
                viewBox="0 0 18 18"
              >
                <path
                  id="Icon_material-check-circle"
                  data-name="Icon material-check-circle"
                  d="M12,3a9,9,0,1,0,9,9A9,9,0,0,0,12,3ZM10.2,16.5,5.7,12l1.269-1.269L10.2,13.953l6.831-6.831L18.3,8.4Z"
                  transform="translate(-3 -3)"
                  fill="#31006F"
                />
              </svg>
            </span>
            <span
              class="unchecked"
              v-if="orderData.extra_cost_payer == 1"
              @click="orderData.extra_cost_payer = 2"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="17.92"
                height="17.92"
                viewBox="0 0 17.92 17.92"
              >
                <path
                  id="Icon_material-radio-button-unchecked"
                  data-name="Icon material-radio-button-unchecked"
                  d="M11.96,3a8.96,8.96,0,1,0,8.96,8.96A8.963,8.963,0,0,0,11.96,3Zm0,16.128a7.168,7.168,0,1,1,7.168-7.168A7.166,7.166,0,0,1,11.96,19.128Z"
                  transform="translate(-3 -3)"
                />
              </svg>
            </span>
            <input
              style="cursor: pointer"
              :value="2"
              v-model="orderData.extra_cost_payer"
              id="extra_cost_payer1"
              class="custom-control-primary mr-1"
              type="radio"
              name="radiosGroup"
            />
            <label
              style="cursor: pointer; font-size: 0.875rem; margin-left: 1.5rem"
              :style="[
                orderData.extra_cost_payer != 1 
                  ? { color: '#31006F' }
                  : { color: '#6E6B7B' },
              ]" for="extra_cost_payer1"
              >المرسل</label
            >
          </span>
          
        </div>
        <!-- <div style="display: flex; align-items: center; grid-column: span 3">
          <form>
            <vs-checkbox
              name="checkbox"
              v-model="orderData.is_office_given"
              class="remember m-0"
              @change="changeOffice(orderData.government_id,orderData.area_id,orderData.is_office_given)" 
              >{{ $t("doYouWantDeliverOrderNearstBranch") }}</vs-checkbox
            >
          </form>
        </div> -->
        <div style="align-items: center; grid-column: span 12">
          <form style="display: flex;">
            <vs-checkbox
              v-if="orderData.is_order != 4"
              name="checkbox"
              v-model="orderData.can_open"
              class="remember mr-8"
              >{{ $t("canOpen") }}</vs-checkbox
            >
            <vs-checkbox
              v-if="orderData.is_order != 4"
              name="checkbox"
              :disabled="orderData.can_open == 0"
              v-model="orderData.is_measurable"
              class="remember mr-8"
              >{{ $t("isMeasurable") }}</vs-checkbox
            >
            <vs-checkbox
              v-if="orderData.is_order != 4"
              name="checkbox"
              v-model="orderData.is_fragile"
              class="remember mr-8"
              >{{ $t("isFragile") }}
            </vs-checkbox>
            <!-- <vs-checkbox
              name="checkbox"
              v-model="orderData.accept_20_plus_5_dinar"
              class="remember mr-8"
              >{{ $t("Aceept20Plus5Dinar") }}</vs-checkbox
            > -->
          </form>
          <!-- Alert for "fragile" -->
          <div v-if="orderData.is_order != 4 && orderData.is_fragile"
            class="alert alert-success mt-4"
            style="background: #e0f7e9; padding: 10px; border-radius: 5px; color: #2e7d32;"
          >
            {{ $t("fragileSelectedMessage") }}
          </div>
          <!-- Alert for "not fragile" -->
          <div v-else-if="orderData.is_order != 4"
            class="alert alert-warning mt-4"
            style="background: #fff3cd; padding: 10px; border-radius: 5px; color: #856404;"
          >
            {{ $t("fragileNotSelectedMessage") }}
          </div>
          <!-- Alert for "sealed / not allowed to open" -->
          <div v-if="orderData.is_order != 4 && orderData.can_open == 0"
            class="alert alert-success mt-4"
            style="background: #e0f7e9; padding: 10px; border-radius: 5px; color: #2e7d32;"
          >
            {{ $t("sealedPackagingSelectedMessage") }}
          </div>
          <!-- Alert for "open allowed" -->
          <div v-else-if="orderData.is_order != 4"
            class="alert alert-warning mt-4"
            style="background: #fff3cd; padding: 10px; border-radius: 5px; color: #856404;"
          >
            {{ $t("sealedPackagingNotSelectedMessage") }}
          </div>
        </div>
        <!-- <div style="display: flex; align-items: center; grid-column: span 2">
          <form>
            <vs-checkbox
              name="checkbox"
              v-model="orderData.has_packaging_bag"
              class="remember m-0"
              >تغليف الطلب ؟</vs-checkbox
            >
          </form>
        </div> -->
        <!-- Return Summry -->
        <div
          v-if="![0, 4].includes(orderData.is_order)"
          class="w-full"
          style="grid-column: span 12"
        >
          <label class="font-bold"
            > {{ $t("contentReturn") }} : 
            <span style="font-size: 1.2rem" class="text-danger font-bold">*</span>
          </label>
          <vs-input
            maxlength="100"
            minlength="3"
            v-model="orderData.return_summary"
            class="w-full"
            type="text"
            v-validate="'required'"
            name="return_summary"
          />
          <span style="font-size: 0.7rem" class="text-danger err-msg">{{
            errors.first("return_summary")
          }}</span>
        </div>

        <!-- Do you want add new order -->
        <div style="grid-column: span 12">
          <form class="w-full flex items-center justify-start">
            <vs-checkbox name="checkbox" v-model="addNew" class="remember m-0"
              >هل تريد إضافة طلب أخر ؟</vs-checkbox
            >
          </form>
        </div>
        <addProductsSection
          :edit="false"
          ref="products"
          v-if="have_stock === 1 && Object.keys(resend_with_new_order).length === 0"
        />
      </div>
      <div
        class="flex flex-wrap items-center p-6 justify-end footer"
        slot="footer"
      >
      <!-- Remove Save Buttton -->
        <!-- <button
          class="mr-6 send-order"
          :class="{ 'opacity-btn1': !isFormValid }"
          @click="submitData(4)"
          :disabled="!isFormValid"
        >
          {{
            loading && orderData.status == 4 ? "جاري الارسال ..." : $t("send")
          }}
        </button> -->
        <button
          class="mr-6 save-order"
          :class="{ 'opacity-btn': !isFormValid }"
          @click="submitData(1)"
          :disabled="!isFormValid"
        >
          {{ loading && orderData.status == 1 ? "جاري الحفظ ..." : $t("save") }}
        </button>
        <router-link to="/">
          <button class="mr-6 back-order">{{ $t("back") }}</button>
        </router-link>
      </div>
    </div>
  </div>
  <div class="flex justify-center items-center" style="height: 70vh" v-else>
    <SpinnerColor2Vue />
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
import tour from "@/mixins/tour.js";
import SpinnerColor2Vue from "../components/table-components/SpinnerColor2.vue";
import notifyState from "../../mixins/notifyState";
import landLine from "@/mixins/landLine.js";
import addProductsSection from "../products/SelectProductsSection.vue";
import removeSpaceNumber from "@/mixins/removeSpaceNumber.js";
import SelectInputVue from "../../layouts/components/SelectInput.vue";
import SkeletonLoadingVue from "@/layouts/components/SkeletonLoading.vue";
import regionsMixins from "@/mixins/regions.js";
import validationPhone from "@/mixins/validationPhone.js";
import searchReagions from "@/mixins/searchRegions.js";
import Axios from "axios";

export default {
  mixins: [
    tour,
    notifyState,
    landLine,
    removeSpaceNumber,
    regionsMixins,
    validationPhone,
    searchReagions,
  ],
  data() {
    return {
      showCustomerRate: false,
      customerRateData: {
        alertClass: 'alert-info',
        iconClass: 'fa-circle-info',
        headerText: '',
        detailsText: '',
      },
      resultSubCustomers: "",
      orderData: {
        second_client: "",
        return_amount: null,
        receiver: "",
        api_followup_phone: "",
        phone1: "",
        phone2: "",
        government_id: null,
        return_summary: "",
        area_id: null,
        is_order: 0,
        address: "",
        amount_to_be_collected: null,
        invoice_number: null,
        order_summary: "",
        notes: "",
        is_office_given: false,
        status: null,
        can_open: 0,
        is_measurable: 0,
        is_fragile: 0,
        is_bank_payment: 0,
        phone1ErrorMessage: '',
        phone2ErrorMessage: '',
        shipping_payer: 1,
        extra_cost_payer: 1,
        payment_commission_payer: 1,
        //accept_50_dinar: 1,
        api_followup_phoneErrorMessage: '',
        added_by_portal: 1,
        pieces_count: 0,
        //accept_20_plus_5_dinar: 0,
        // has_packaging_bag: 0,
      },
      search: "",
      resultGovs: "",
      addNew: false,
      loading: false,
      status: undefined,
      steps: [
        {
          target: '[data-order-tour-step="1"]', // We're using document.querySelector() under the hood
          header: {
            title: "تفاصيل الطلب",
          },
          content: `في خانة المتجر الفرعي يفضل اضافة اسم المرسل الفعلي للطلب لسهولة عملية التسليم`,
          params: {
            placement: "top",
            enableScrolling: false,
          },
        },
        {
          target: '[data-tour-step="8"]',
          header: {
            title: "متابعة المحادثات",
          },
          content: `يمكنك متابعة المحادثات الخاصة بك من هنا (الطلبات / المهمات / تذاكر الدعم)`,
        },
      ],
      loadingGov: false,
    };
  },
  computed: {
    ...mapGetters("dataList", ["active_governments", "payload", "order_code","sub_clients", "order_id", "default_values"]),
    ...mapGetters("userData", ["have_stock"]),
    ...mapState("externalApi", ["regions"]),
    ...mapState("dataList", ["resend_with_new_order"]),
    isFormValid() {
      return !this.errors.any() && this.orderData.government_id > 0 && this.orderData.amount_to_be_collected && this.orderData.order_summary.length>2 && this.orderData.receiver.length>2;
    },
    totalAmount() {
      let total = this.orderData.amount_to_be_collected;
      let cost = this.areaResultCost && this.orderData.area_id ? this.areaResultCost : this.resultCost;
      let shipping_cost = this.orderData.shipping_payer == 1 ? +cost : 0;
      return +total + +shipping_cost;
    },
    orderTypes() {
      if (this.payload.length > 0) {
        if (Object.keys(this.resend_with_new_order).length !== 0) {
          // Remove item with id = 4 ("عربون") from the order types
          return this.payload.filter(item => item.id != 4);
        } else {
          return [...this.payload];
        }
      }
      return [];
    },
  },
  watch: {
    "orderData.is_office_given": {
      handler(val) {
        if (val) {
          this.orderData.address = "تسليم مكتب";
        } else {
          this.orderData.address = "";
        }
      },
    },
    "orderData.is_order": {
      handler(val) {
        if (val == 4) {
          this.orderData.is_fragile = 0;
          this.orderData.can_open = 0;
          this.orderData.is_measurable = 0;
        }
      },
    },
    "orderData.can_open": {
      handler(val) {
        if (val == 0) {
          this.orderData.is_measurable  = 0;
        }
      },
    },
  },
  components: {
    SpinnerColor2Vue,
    addProductsSection,
    SelectInputVue,
    SkeletonLoadingVue,
  },
  methods: {
    ...mapActions("dataList", ["addOrder", "postOrder", "resendWithNewOrder", "resendRequest"]),
    ...mapActions("externalApi", ["fetchRegions", "getCost","getAreaCost"]),


    closeDialog() {
      const handleAnimation=setTimeout( () => {
                 this.$refs.dialogCont.classList.add("animate");
                 this.$refs.dialogCont.classList.remove("fix-animate");
                 clearTimeout(handleAnimation)
                },0)
                const close=setTimeout( () => {
                  this.$refs.dialog.close();
                  clearTimeout(close)
                },1000)
    },
    initValues() {
      Object.keys(this.orderData).forEach((key) => {
        this.orderData[key] = "";
      });
      this.orderData.is_office_given = false;
      this.addNew = false;
    },
    handleApiErrors() {
      const errMsg = this.$store.state.dataList.err_msg;
      if (errMsg.includes('رقم التليفون الأول غير صحيح')) {
        this.orderData.phone1ErrorMessage = errMsg;
      } else if (errMsg.includes('رقم التليفون الثاني غير صحيح')) {
        this.orderData.phone2ErrorMessage = errMsg;
      } else if (errMsg.includes('رقم متابعة الطلب غير صحيح')) {
        this.orderData.api_followup_phoneErrorMessage = errMsg;
      }
    },
    searchGov() {
      if (this.search == "") {
        this.resultGovs = this.active_governments;
      } else {
        this.resultGovs = this.active_governments.filter((governments) =>
          governments.name.toLowerCase().includes(this.search.toLowerCase())
        );
      }
    },
    submitData(status) {
      
      this.$validator.validateAll().then(async (result) => {
        if (this.orderData.is_order == 0) {
          this.orderData.return_summary = "";
        }
        if (this.orderData.is_order == 4) {
          this.orderData.return_summary = "عربون";
          //default value in deposit order type
          this.orderData.is_fragile = 0;
          this.orderData.can_open = 0;
          this.orderData.is_measurable = 0;
        } else{
          //chenge true and false to 1 and 0
          this.orderData.can_open = this.orderData.can_open ? 1 : 0,
          this.orderData.is_measurable = this.orderData.is_measurable ? 1 : 0,
          this.orderData.is_fragile = this.orderData.is_fragile ? 1 : 0
        }
        // if (this.orderData.has_packaging_bag)
        //   this.orderData.has_packaging_bag = 1;
        if (result && this.validPhone) {
          if (this.have_stock === 1 && Object.keys(this.resend_with_new_order).length === 0) {
            let products = [...this.$refs.products.slectedProducts];
            products = products.filter((product) => product.selected == true);
            if (products.length) {
              this.orderData.order_products = products;
            }
          }
          this.loading = true;
          this.orderData.status = status;
          this.orderData.added_by_portal = 1;
          this.orderData.is_bank_payment = this.orderData.is_bank_payment ? 1 : 0;
          // this.formatNumberPhone("orderData", "phone1");
          // this.formatNumberPhone("orderData", "phone2");
          // this.formatNumberPhone("orderData", "api_followup_phone");
          this.orderData.check_duplicate="true";
          const submitResult = await this.postOrder(this.orderData);
          this.loading = false;
          if (submitResult && submitResult.success == 1) {
            if(Object.keys(this.resend_with_new_order).length){
              await this.resendRequest({
                "id" : this.resend_with_new_order.id,
                "type" : 2,
                "orderId" : this.order_id,
              });
              this.notifySuccess("addToastWithNewOrder");
              //clear resend with new
              this.resendWithNewOrder({});
            }else{
              this.notifySuccess("addToast");
            }
            if (!this.addNew) {
              this.$router.push({ path: `/OrderDetails/${this.order_code}` });
            } else {
              this.initValues();
            }
          } else if (submitResult && submitResult.error_msg && submitResult.error_msg.includes('مكرر')) {
            const handleAnimation=setTimeout(() => {
              this.$refs.dialogCont.classList.remove("animate");
              this.$refs.dialogCont.classList.add("fix-animate");
              clearTimeout(handleAnimation)
            },10)
            this.$refs.dialog.show()
          } else {
            this.handleApiErrors();
            this.notifyFaild("faildAdd", submitResult ? submitResult.error_msg : this.$store.state.dataList.err_msg);
          }
        }
      });
    },
    async submitData_2(status) {
                this.$refs.dialogCont.classList.add("animate");
                this.$refs.dialogCont.classList.remove("fix-animate");
              this.$refs.dialog.close()
              this.orderData.added_by_portal = 1;
      delete this.orderData.check_duplicate;
      const submitResult = await this.postOrder(this.orderData);
      if (submitResult && submitResult.success == 1) {
        if(Object.keys(this.resend_with_new_order).length){
              await this.resendRequest({
                "id" : this.resend_with_new_order.id,
                "type" : 2,
                "orderId" : this.order_id,
              });
              this.notifySuccess("addToastWithNewOrder");
              this.resendWithNewOrder({});
            } else {
              this.notifySuccess("addToast");
            }
            if (!this.addNew) {
              this.$router.push({ path: `/OrderDetails/${this.order_code}` });
            } else {
              this.initValues();
            }
          } else {
            this.handleApiErrors();
            this.notifyFaild("faildAdd", submitResult ? submitResult.error_msg : this.$store.state.dataList.err_msg);
          }

    },
    clearErrorMessage(inputName) {
      this[`${inputName}ErrorMessage`] = '';
    },

    async getCustomerRate(phone) {
      if (!phone) return;

      try {
        const res = await Axios.get('/order/customer-rate', { params: { phone1: phone } });
        if (!res || !res.data) return;

        const { total, rate } = res.data;

        this.showCustomerRate = true;

        // reset
        this.customerRateData = { alertClass: '', headerText: '' };

        if (total === 0) {
          this.customerRateData.alertClass = 'alert-info';
          this.customerRateData.headerText = 'زبون جديد';
        } else if (rate >= 80) {
          this.customerRateData.alertClass = 'alert-success';
          this.customerRateData.headerText = `زبون ممتاز - نسبة الاستلام : ${rate}%`;
        } else if (rate >= 50) {
          this.customerRateData.alertClass = 'alert-warning';
          this.customerRateData.headerText = `زبون متوسط - نسبة الاستلام : ${rate}%`;
        } else {
          this.customerRateData.alertClass = 'alert-danger';
          this.customerRateData.headerText = `تحذير - نسبة استلام منخفضة : ${rate}%`;
        }

      } catch (e) {
        console.log(e);
        this.showCustomerRate = false;
      }
    }

  },
  async created() {
    this.loadingGov = true;
    await this.addOrder();
    
    this.resultGovs = this.active_governments;
    this.resultSubCustomers = this.sub_clients
    //this.orderData.accept_20_plus_5_dinar = this.default_values.accept_20_plus_5_dinar;
    this.orderData.can_open = this.default_values.can_open;
    this.orderData.is_measurable = this.default_values.is_measurable;
    this.orderData.is_fragile = this.default_values.is_fragile;
    this.loadingGov = false;

  },
  mounted() {
    if (this.runWalkthrough()) {
      localStorage.setItem("addOrderTour", false);
      this.startTour("addOrder");
      setTimeout(() => {
        window.scrollTo(0, 20);
      }, 500);
      this.$watch(
        () => {
          return this.$tours.addOrder.currentStep;
        },
        (val) => {
          if (val == 1) {
            const nextStep = document.querySelector(".v-step__button");
            nextStep.addEventListener("click", () => {
              this.$router.push({ path: "/apps/chat/id", query: { type: 3 } });
            });
          }
        }
      );
    }
    if(this.resend_with_new_order){
      this.orderData.order_summary = this.resend_with_new_order.order_summary;
    }
  },
  unmounted() {
    this.resendWithNewOrder({})
  },
  beforeRouteLeave(to, from, next) {
    // Clear the resend state if set
    this.resendWithNewOrder({})
  next();
}
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/vuexy/_addOrder.scss";
@import "@/assets/scss/vuexy/_product.scss";

.animate{
  transform: translateX(-2000px) translateY(10%) !important;
}
.fix-animate{
  transform: translateX(-50%) translateY(10%);
}
.dialog{
  width: 500px;
  height: 200px;
  padding: 30px;
  border-radius: 10px;
  background-color: #4F2F4C;
  color: #fff;
  position: absolute;
  left: 50%;
  top: 50%;
  transition: all 0.5s linear;
}
dialog{
width: 120%;
height: 120%;
transform: translateX(-10%);
  border: none;
  padding: 30px;
  z-index: 99999;
  background-color: rgba(80, 47, 76, 0.2196078431);
}
  .yes-no{
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .yes,.no{
    background-color: #4F2F4C;
    border: none;
    outline: none;
    color: #fff;
    cursor: pointer;
    margin-bottom: 40px;
    width: 80px;
    border-radius: 8px;
  }
  .yes:hover,.no:hover{
    background-color: #fff;
    color: #4F2F4C;
  }

  .fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}


</style>

<style lang="scss">
.form-inputs {
  .vue-tel-input {
    .vti__input {
      direction: rtl;
    }
  }
}

.second-input {
  .con-select {
    label {
      font-size: 0.875rem;
      color: #212121;
      line-height: 1.3125rem;
      margin-bottom: 0.4375rem;
      display: block;
    }
    width: 100%;
    margin: 0rem;
    .input-select-con {
      width: 100%;
      input {
        width: 100%;
        font-family: "Cairo";
        font-size: 0.75rem;
        height: 2.4375rem;
      }
      input::placeholder {
        color: #6e6b7b;
        opacity: 50%;
        font-size: 0.75rem;
        line-height: 1.3125rem;
        font-family: "cairo";
      }
    }
  }
}
.input-select {
  width: 100%;
}
.vs-select--options {
  ul {
    li {
      button {
        span {
          font-family: "cairo";
        }
      }
    }
  }
}
.custom-select {
  .inner-input {
    margin-bottom: 0px;
  }
}
.product {
  .vs-checkbox-primary .vs-checkbox {
    border: 2px solid #fff !important;
    width: 20px;
    height: 20px;
    margin-right: 11px;
    border-radius: 4px;
  }
  .con-slot-label {
    color: #fff;
    font-size: 14px;
    font-weight: 600;
    line-height: 27px;
  }
}
.bank-payment-wrapper {
  grid-column: 1 / -1;
  width: 100%;
  margin-top: 16px;
}

.bank-payment-card {
  border: 1px solid #90caf9;
  background: #e3f2fd;
  padding: 12px 16px;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.bank-checkbox {
  display: flex;
  align-items: center;
  gap: 10px;
  font-weight: 600;
  color: #0d47a1;
}

.bank-checkbox input[type="checkbox"] {
  width: 18px;
  height: 18px;
  accent-color: #1976d2;
  cursor: pointer;
}
.customer-rate-alert {
  display: inline-flex;
  /* بدل inline عشان padding و background يشتغلوا */
  align-items: center;
  gap: 8px;
  padding: 4px 8px;
  border-radius: 6px;
  font-weight: 600;
  font-size: 0.85rem;
  font-family: "Cairo";
}

.customer-rate-alert.alert-info {
  background-color: #e0f7fa;
  color: #006064;
}

.customer-rate-alert.alert-success {
  background-color: #e8f5e9;
  color: #2e7d32;
}

.customer-rate-alert.alert-warning {
  background-color: #fff8e1;
  color: #f9a825;
}

.customer-rate-alert.alert-danger {
  background-color: #ffebee;
  color: #c62828;
}

</style>